<div class="modal-header">
    <h4 class="modal-title pull-left text-break">
        <span translate>New message to</span>
        {{
            reply
                ? reply.author.name || reply.author.email
                : ticket.firstMessageCreator.name || ticket.firstMessageCreator.email
        }}
    </h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    @if (reply) {
        <div class="d-flex flex-row align-items-start" style="padding-right: 10px">
            <sb-user-avatar class="user-avatar-sm" [user]="reply.author" [size]="'small'"></sb-user-avatar>

            <div class="w-100">
                <div class="social-reply-text">
                    <a (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author }); decline()">
                        {{ reply.author.name || reply.author.email }}
                        @if (reply.author.socialMediaAccountInfo?.accountName) {
                            <!--                            todo: checi is span needed-->
                            <span>({{ reply.author.socialMediaAccountInfo?.accountName }} )</span>
                        }
                    </a>
                    <br />

                    <app-highlight-reply-mention
                        class="notification-list-item-text"
                        [message]="reply.message.text | encodeHtmlSymbols"
                        [mentionedUsers]="[]">
                    </app-highlight-reply-mention>
                </div>

                @for (attachment of reply.contentAttachments; track attachment) {
                    <sb-file-view
                        [attachment]="attachment"
                        [isFilePreviewInModal]="true"
                        class="d-block mw-300px"
                        [permalink]="ticket.permalink"
                        [ngClass]="{ 'mw-100': attachment.attachmentType === attachmentTypeEnum.link }">
                    </sb-file-view>
                }

                @if (reply.notContentAttachments && reply.notContentAttachments.length) {
                    <div class="attachments-block mt-2">
                        @for (attachment of reply.notContentAttachments; track attachment; let idx = $index) {
                            <sb-file-preview
                                class="file-container"
                                [permalink]="ticket.permalink"
                                [attachment]="attachment"
                                [attachments]="reply.notContentAttachments"
                                [fileIndex]="idx">
                            </sb-file-preview>
                        }
                        <div class="clearfix"></div>
                    </div>
                }
                <div class="clearfix"></div>
                <small class="text-light" tooltip="{{ reply.creationTime | date: 'dd.MM.yyyy HH:mm' }}">
                    {{ reply.creationTime | timeAgo }}
                </small>
            </div>
        </div>
    } @else {
        <div class="d-flex flex-row align-items-start" style="padding-right: 10px">
            @if (ticket.firstMessageCreator) {
                <sb-user-avatar class="user-avatar-sm" [user]="ticket.firstMessageCreator" [size]="'small'">
                </sb-user-avatar>
            }

            <div class="w-100">
                <div class="social-reply-text">
                    <a
                        class="user-name text-break"
                        (click)="
                            rightPanelService.open(rightPanelTypeEnum.user, {
                                user: ticket.firstMessageCreator,
                            });
                            decline()
                        ">
                        {{ ticket.firstMessageCreator.name || ticket.firstMessageCreator.email }}
                        @if (
                            ticket.source === ticketSourceEnum.instagram &&
                            ticket.firstMessageCreator.socialMediaAccountInfo?.accountName
                        ) {
                            <span
                                >&nbsp; (&#64;{{
                                    ticket.firstMessageCreator.socialMediaAccountInfo?.accountName
                                }})</span
                            >
                        }
                    </a>
                    <br />

                    <app-highlight-reply-mention
                        class="notification-list-item-text"
                        [message]="ticket.message.text | encodeHtmlSymbols"
                        [mentionedUsers]="[]"></app-highlight-reply-mention>
                </div>
                @for (attachment of ticket.contentAttachments; track attachment) {
                    <sb-file-view
                        [attachment]="attachment"
                        class="d-block mw-300px"
                        [isFilePreviewInModal]="true"
                        [permalink]="ticket.permalink"
                        [ngClass]="{ 'mw-100': attachment.attachmentType === attachmentTypeEnum.link }">
                    </sb-file-view>
                }

                @if (ticket.notContentAttachments && ticket.notContentAttachments.length) {
                    <div class="attachments-block mt-2">
                        @for (attachment of ticket.notContentAttachments; track attachment; let idx = $index) {
                            <sb-file-preview
                                class="file-container"
                                [attachments]="ticket.notContentAttachments"
                                [attachment]="attachment"
                                [permalink]="ticket.permalink"
                                [fileIndex]="idx"></sb-file-preview>
                        }
                        <div class="clearfix"></div>
                    </div>
                }
                <div class="clearfix"></div>
                <small class="text-light" tooltip="{{ ticket.firstMessageCreationTime | date: 'dd.MM.yyyy HH:mm' }}">
                    {{ ticket.firstMessageCreationTime | timeAgo }}
                </small>
            </div>
        </div>
    }

    <div class="d-flex mt-3">
        <sb-user-avatar
            class="user-avatar-sm"
            [size]="'small'"
            [user]="commonDataService.user"
            [isNeedTooltip]="false"></sb-user-avatar>
        <div class="new-reply-wrapper">
            <div class="smile-field-container">
                @if (!commonDataService.isOneTime && replyTemplateService.allReplyTemplates.length && quillEditor) {
                    <sb-quill-reply-templates [isTextContent]="true" [quillEditor]="quillEditor" [reply]="newReply">
                    </sb-quill-reply-templates>
                }

                <quill-editor
                    id="add-private-reply-modal-editor"
                    [(ngModel)]="newReply.html"
                    (onContentChanged)="onReplyChanged($event, newReply)"
                    (onEditorCreated)="onEditorCreated($event)"
                    [modules]="quillConfig"
                    placeholder="{{ 'Write comment here...' | translate }}"
                    format="html">
                </quill-editor>

                <sb-quill-emoji-picker
                    (updateQuillSelection)="updateQuillSelection(quillEditor)"
                    (emojiSelect)="
                        replyTemplateManagerService.chooseReplyTemplate({
                            $event: $event.$event,
                            templateText: $event.emoji,
                            quillEditor,
                            quillRange,
                            isSmile: true,
                        })
                    ">
                </sb-quill-emoji-picker>
            </div>

            <div class="content-attachments-wrapper">
                @for (
                    attachment of newReply.attachments | filterContentAttachments: true : newReply.attachments.length;
                    track attachment;
                    let idx = $index
                ) {
                    <div class="content-attachments-block">
                        <button
                            type="button"
                            class="btn btn-icon btn-close btn-transparent"
                            aria-label="Close"
                            (click)="deleteGifAttachment(attachment)">
                            <sb-inline-svg
                                class="icon icon-close"
                                aria-label="My icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                            </sb-inline-svg>
                        </button>
                        <sb-file-view
                            [isFilePreviewInModal]="true"
                            [attachment]="attachment"
                            [permalink]="ticket.permalink">
                        </sb-file-view>
                    </div>
                }
            </div>

            <div class="attachments-block mt-2">
                @for (attachment of newReply.attachments; track attachment; let idx = $index) {
                    @if (!attachment.isContentPart) {
                        <sb-file-preview
                            class="file-container"
                            [attachment]="attachment"
                            [fileIndex]="idx"
                            [canBeRemoved]="true"
                            [permalink]="ticket.permalink"
                            [attachments]="newReply.attachments"></sb-file-preview>
                    }
                }
                <div class="clearfix"></div>
            </div>

            <div class="mt-2">
                <div class="buttons-panel text-end">
                    @if (isShowGiphyPicker) {
                        <sb-giphy-picker (add)="addGifAttachment($event)"></sb-giphy-picker>
                    }

                    <button
                        class="btn btn-icon"
                        (click)="openReplyTemplatesModal($event, quillEditor)"
                        tooltip="{{ 'Insert a saved template' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                        </sb-inline-svg>
                    </button>
                    <button
                        class="btn btn-icon"
                        (click)="openAttachmentsModal()"
                        tooltip="{{ 'Attachments' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                        </sb-inline-svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="
            (newReply | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : false) || isAdding
        "
        (click)="addReply()"
        translate>
        Send message
    </button>
</div>
@if (isNeedSecondBackdrop) {
    <bs-modal-backdrop class="modal-backdrop in show"></bs-modal-backdrop>
}
